import React from 'react';
import { connect } from 'react-redux';

import BecomeApartnerComponent from '../components/app/BecomeAnInvestor/BecomeAnInvestor';

import * as actions from '../actions/becomeAnInvestor';

const BecomeAnInvestor = (props) => {
  return (
    <BecomeApartnerComponent {...props} />
  );
};

export default connect(({ investor }) => investor, actions)(BecomeAnInvestor);
